import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { REST_ERROR_CODES } from 'src/apis/exception';
import { isDefinedAxiosRESTFailure } from 'src/apis/utils';
import { ProfileQueryKeys } from 'src/hooks/useProfileQuery';
import { useRestMutation } from 'src/hooks/useRestMutation';
import { getInventoryAtom } from 'src/stores/auth/atoms';
import { ProfileApiList, UpdateProfileNicknameParams, UpdateProfileNicknameResponse } from 'src/stores/profile/apis';
import { showCommonErrorToastAtom, showToastAtom } from 'src/stores/toast/atoms';
import { ToastType } from 'src/types/Toast';
const useNicknameChange = () => {
  const {
    t
  } = useTranslation();
  const queryClient = useQueryClient();
  const getInventory = useSetAtom(getInventoryAtom);
  const showCommonErrorToast = useSetAtom(showCommonErrorToastAtom);
  const showToast = useSetAtom(showToastAtom);
  const {
    isPending,
    mutateAsync,
    isSuccess
  } = useRestMutation<UpdateProfileNicknameParams, UpdateProfileNicknameResponse, unknown>({
    method: 'put',
    path: ProfileApiList.ProfileNickname,
    options: {
      onSuccess: async () => {
        await Promise.all([getInventory(), queryClient.invalidateQueries({
          queryKey: ProfileQueryKeys.getProfileCard('MY_PROFILE'),
          refetchType: 'all'
        })]);
      },
      onError: error => {
        if (isDefinedAxiosRESTFailure(error, REST_ERROR_CODES.NOT_ENOUGH_FREE_QUOTA)) {
          const {
            limitValue
          } = error.response?.data?.error?.data?.extraInfo ?? {};
          showToast({
            type: ToastType.ERROR,
            message: t('toast.name_change_limit', {
              max: limitValue ?? 1
            })
          });
          return;
        }
        showCommonErrorToast();
      }
    }
  });
  const updateNickname = async (nickname: string) => {
    try {
      await mutateAsync({
        nickname
      });
    } catch {
      // 에러는 onError 콜백에서 처리됨
    }
  };
  return {
    updateNickname,
    isPending,
    isSuccess
  };
};
export default useNicknameChange;